module.exports = __webpack_public_path__ + "static/media/satv_m1.ec2ab4c9.gif";